import React from "react";
import { Badge, Modal } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState, useEffect } from "react";
import {
  DeleteTrackImport,
  GetImportHistory,
} from "../../../../api/User/ACG/TrackImportApi";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";

const TrackImportHistory = () => {
  const [data, setData] = useState([]);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const column = [
    {
      title: "User Name",
      field: "userName",
    },
    {
      title: "License ID",
      field: "licenseID",
    },
    {
      title: "Client Name",
      field: "clientName",
    },
    {
      title: "Record Count",
      field: "recordCount",
    },
    {
      align: 'center',
      title: "Status",
      render: (rowData) => {
        let badgeColor;
        switch (rowData.status) {
          case "Successful":
            badgeColor = "success";
            break;
          case "Failed":
            badgeColor = "danger";
            break;
        }
        return (<Badge
          pill
          className="fw-normal py-1 px-3"
          bg={badgeColor}
          style={{ fontSize: "10px" }}
        >
          {rowData.status}
        </Badge >)
      }
    },
    {
      title: "Imported Date",
      field: "date",
      type: 'date'
    },
  ];

  useEffect(() => {
    getData();
    setSelectedRowData(null);
  }, []);

  const getData = () => {
    GetImportHistory()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }));
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >

            Delete Track Import History
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <DeleteModal
            onClickYes={() => {
              DeleteTrackImport(selectedRowData?.id).then((res) => {
                if(res.status === 200 || res.status === 204){
                toastFile("delete");
                setShowModal(false);
                getData()
                }
              })
            }}
            onClickNo={() => setShowModal(false)}
          />

        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        {/* <CustomButton
          onClick={() => {
            setWitchAction("deleteall");
            setShowModal(true);
          }}
        >
          Delete All Records
        </CustomButton> */}
      </div>
      <CustomMaterialTable
        isEdit={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default TrackImportHistory;
